var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTradingSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 23C10.3138 23 13 20.3138 13 17C13 16.8431 12.9908 16.6769 12.9815 16.52C12.7508 13.5939 10.4061 11.2492 7.47999 11.0185C7.32307 11.0092 7.15692 11 7 11C3.68615 11 1 13.6862 1 17C1 20.3138 3.68615 23 7 23ZM7.65904 14.642C7.52781 14.4004 7.27492 14.25 7 14.25C6.72508 14.25 6.47219 14.4004 6.34096 14.642L5.74292 15.7429L4.642 16.341C4.40042 16.4722 4.25 16.7251 4.25 17C4.25 17.2749 4.40042 17.5278 4.642 17.659L5.74292 18.2571L6.34096 19.358C6.47219 19.5996 6.72508 19.75 7 19.75C7.27492 19.75 7.52781 19.5996 7.65904 19.358L8.25708 18.2571L9.358 17.659C9.59958 17.5278 9.75 17.2749 9.75 17C9.75 16.7251 9.59958 16.4722 9.358 16.341L8.25708 15.7429L7.65904 14.642ZM6.95504 16.654L7 16.5712L7.04496 16.654C7.11412 16.7813 7.21868 16.8859 7.346 16.955L7.42877 17L7.346 17.045C7.21868 17.1141 7.11412 17.2187 7.04496 17.346L7 17.4288L6.95504 17.346C6.88588 17.2187 6.78132 17.1141 6.654 17.045L6.57123 17L6.654 16.955C6.78132 16.8859 6.88588 16.7813 6.95504 16.654Z",
    fill: "#6C84F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15C22 18.87 18.87 22 15 22L16.05 20.25",
    fill: "#6C84F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15C22 18.87 18.87 22 15 22L16.05 20.25",
    stroke: "#6C84F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9C2 5.13 5.13 2 9 2L7.95 3.75",
    fill: "#6C84F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9C2 5.13 5.13 2 9 2L7.95 3.75",
    stroke: "#6C84F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12C20.3138 12 23 9.31385 23 6C23 5.84308 22.9908 5.67693 22.9815 5.52001C22.7508 2.59386 20.4061 0.249221 17.48 0.0184514C17.3231 0.00922063 17.1569 0 17 0C13.6862 0 11 2.68615 11 6C11 9.31385 13.6862 12 17 12ZM17.659 3.642C17.5278 3.40042 17.2749 3.25 17 3.25C16.7251 3.25 16.4722 3.40042 16.341 3.642L15.7429 4.74292L14.642 5.34096C14.4004 5.47219 14.25 5.72508 14.25 6C14.25 6.27492 14.4004 6.52781 14.642 6.65904L15.7429 7.25708L16.341 8.358C16.4722 8.59958 16.7251 8.75 17 8.75C17.2749 8.75 17.5278 8.59958 17.659 8.358L18.2571 7.25708L19.358 6.65904C19.5996 6.52781 19.75 6.27492 19.75 6C19.75 5.72508 19.5996 5.47219 19.358 5.34096L18.2571 4.74292L17.659 3.642ZM16.955 5.654L17 5.57123L17.045 5.654C17.1141 5.78132 17.2187 5.88588 17.346 5.95504L17.4288 6L17.346 6.04496C17.2187 6.11412 17.1141 6.21868 17.045 6.346L17 6.42877L16.955 6.346C16.8859 6.21868 16.7813 6.11412 16.654 6.04496L16.5712 6L16.654 5.95504C16.7813 5.88588 16.8859 5.78132 16.955 5.654Z",
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingSvg);
export default __webpack_public_path__ + "static/media/tradingSvg.93b2d3c18f0ee35623eb336899196ab1.svg";
export { ForwardRef as ReactComponent };